var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import * as Long from "long";
import * as React from "react";
import { ButtonSecondarySquareSmall } from "../common/ButtonSecondarySquareSmall";
import { SliderFillHorizontal } from "../common/SliderFillHorizontal";
import { SliderTrackHorizontal } from "../common/SliderTrackHorizontal";
import { Key } from "../key-handler/Key";
var Slider = /** @class */ (function (_super) {
    __extends(Slider, _super);
    function Slider(props, context) {
        var _this = _super.call(this, props, context) || this;
        _this.update = function () {
            if (!_this.slider || !_this.handle) {
                // for shallow rendering
                return;
            }
            var sliderPos = _this.slider["offsetWidth"];
            var handlePos = _this.handle["offsetWidth"];
            _this.setState(__assign({}, _this.state, { grabPos: handlePos, limit: sliderPos - handlePos }));
        };
        _this.handleStart = function () {
            document.addEventListener("mousemove", _this.handleDrag);
            document.addEventListener("mouseup", _this.handleEnd);
            _this.setState(__assign({}, _this.state, { active: true }));
        };
        _this.handleDrag = function (e) {
            e.stopPropagation();
            var onSliderChange = _this.props.onSliderChange;
            var value = _this.position(e) || 0;
            if (onSliderChange) {
                onSliderChange(Long.fromValue(value));
            }
        };
        _this.handleEnd = function () {
            document.removeEventListener("mousemove", _this.handleDrag);
            document.removeEventListener("mouseup", _this.handleEnd);
            _this.setState(__assign({}, _this.state, { active: false }));
        };
        _this.handleKeyDown = function (e) {
            e.preventDefault();
            var keyCode = e.keyCode;
            var _a = _this.props, minValue = _a.minValue, maxValue = _a.maxValue, onSliderChange = _a.onSliderChange, value = _a.value;
            var step = _this.state.step;
            var newValue = value;
            switch (keyCode) {
                case Key.UpArrow:
                case Key.RightArrow:
                    newValue = Long.fromValue(value)
                        .add(step)
                        .greaterThan(maxValue)
                        ? maxValue
                        : Long.fromValue(value).add(step);
                    break;
                case Key.DownArrow:
                case Key.LeftArrow:
                    newValue = Long.fromValue(value)
                        .subtract(step)
                        .lessThan(minValue)
                        ? minValue
                        : Long.fromValue(value).subtract(step);
                    break;
            }
            if (value !== newValue) {
                if (onSliderChange != undefined) {
                    onSliderChange(newValue);
                }
            }
        };
        _this.getPositionFromValue = function (value) {
            var limit = _this.state.limit;
            var _a = _this.props, minValue = _a.minValue, maxValue = _a.maxValue;
            var diffMaxMin = Long.fromValue(maxValue).subtract(minValue);
            if (diffMaxMin.equals(Long.ZERO)) {
                diffMaxMin = Long.ONE;
            }
            // Multiplying by 100 so that when we divide by diff, value is not between 0-1,
            // Which would be impossible because of Long
            var diffValMin = value.subtract(minValue).multiply(100);
            var percentage = diffValMin.divide(diffMaxMin).toNumber() / 100;
            return percentage * limit;
        };
        _this.getValueFromPosition = function (pos) {
            var _a = _this.props, minValue = _a.minValue, maxValue = _a.maxValue;
            var _b = _this.state, limit = _b.limit, step = _b.step;
            var clampValue = _this.clamp(pos, Long.ZERO, limit).multiply(100);
            var percentage = clampValue.divide(limit || 1).toNumber() / 100;
            var diffValue = Long.fromValue(maxValue)
                .subtract(minValue)
                .toNumber();
            var baseVal = step * ((percentage * diffValue) / step);
            var value = Long.fromValue(baseVal).add(minValue);
            return Long.fromValue(_this.clamp(value, minValue, maxValue));
        };
        _this.clamp = function (value, min, max) {
            var val = Long.fromValue(value);
            var minVal = Long.fromValue(min);
            var maxVal = Long.fromValue(max);
            var maxValue = val.lessThanOrEqual(minVal) ? minVal : val;
            return maxValue.greaterThanOrEqual(maxVal) ? maxVal : maxValue;
        };
        _this.position = function (e) {
            if (!_this.slider) {
                return;
            }
            var node = _this.slider;
            var coordinate = !e.touches ? e.clientX : e.touches[0].clientX;
            var direction = node.getBoundingClientRect().left;
            var pos = Long.fromValue(coordinate).subtract(direction);
            return _this.getValueFromPosition(pos);
        };
        var step = _this.props.step || 1;
        _this.state = {
            active: false,
            grabPos: 0,
            limit: 0,
            step: step,
        };
        return _this;
    }
    Slider.prototype.componentDidMount = function () {
        this.update();
    };
    Slider.prototype.render = function () {
        var _this = this;
        var value = this.props.value;
        var limit = this.state.limit;
        var pos = this.getPositionFromValue(Long.fromValue(value || 0));
        var thumbPost = Math.min(pos, limit);
        var handleStyle = {
            left: thumbPost.toString(10) + "px",
        };
        var fillStyle = {
            left: 0,
            position: "absolute",
            top: 0,
            width: (thumbPost + 5).toString(10) + "px",
        };
        return (React.createElement("div", { className: "slider__wrapper" },
            React.createElement("div", { ref: function (s) { return (_this.slider = s); }, className: "slider__container", onMouseDown: this.handleDrag, onMouseUp: this.handleEnd, onTouchStart: this.handleStart, onTouchEnd: this.handleEnd },
                React.createElement(SliderTrackHorizontal, null),
                React.createElement(SliderFillHorizontal, { style: fillStyle }),
                React.createElement("section", { ref: function (sh) { return (_this.handle = sh); }, className: "slider__container--context", onMouseDown: this.handleStart, onTouchMove: this.handleDrag, onTouchEnd: this.handleEnd, onKeyDown: this.handleKeyDown, style: handleStyle, tabIndex: 0 },
                    React.createElement(ButtonSecondarySquareSmall, null)))));
    };
    return Slider;
}(React.Component));
export { Slider };



//////////////////
// WEBPACK FOOTER
// ./src/features/generic/range-slider/Slider.tsx
// module id = 876
// module chunks = 3